// Jumping to a figure head (j / k, 1–9, the figure index, the Artifacts button, in-page lede links).
// Figures below the event stream sit behind content-visibility placeholders that take their real height as they
// render during a smooth scroll, which moves the target; when the scroll ends the jump lands on the head again.
// The head also takes focus (tabindex −1, no scroll), so the next Tab continues inside the figure, not in the index.
//   scrollToId(id) → false when there is no such element
import { scrollBehavior } from "../../lib/motion";

const SETTLE_MS = 2000;

export function scrollToId(id: string): boolean {
  const el = document.getElementById(id);
  if (!el) return false;
  el.scrollIntoView({ behavior: scrollBehavior(), block: "start" });
  if (!el.hasAttribute("tabindex")) el.tabIndex = -1;
  el.focus({ preventScroll: true });
  let passes = 0;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const land = () => {
    clearTimeout(timer);
    const pad = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
    const top = el.getBoundingClientRect().top;
    const doc = document.documentElement;
    const atEnd = window.innerHeight + window.scrollY >= doc.scrollHeight - 2;
    if (Math.abs(top - pad) <= 3 || (atEnd && top > pad)) return;
    el.scrollIntoView({ block: "start" });
    if (++passes < 3) requestAnimationFrame(() => requestAnimationFrame(land));
  };
  if ("onscrollend" in window) {
    window.addEventListener("scrollend", land, { once: true });
    timer = setTimeout(() => window.removeEventListener("scrollend", land), SETTLE_MS);
  } else timer = setTimeout(land, 800);
  return true;
}
